'use client';
import { useEffect } from 'react';

declare global {
	interface Window {
		unlockABTasty?: () => void;
		lockABTastyTag?: boolean;
	}
}

export const UnlockABTasty = () => {
	useEffect(() => {
		// As soon as client is rendered, AB-tasty can be used (otherwise NextJS hydration errors will pop up)
		// See: https://developers.abtasty.com/docs/tag/tag-window#locking-tag-execution
		if (typeof window.unlockABTasty === 'function') {
			window.unlockABTasty();
		} else {
			// If AB-tasty is not loaded yet
			// don't lock it to begin with
			delete window.lockABTastyTag;
		}
	}, []);

	return null;
};
